module.exports = __webpack_public_path__ + "media/2_1.3fc7713f.mp4";